import { render } from "./CartCellChapter.vue?vue&type=template&id=6b5f4348"
import script from "./CartCellChapter.vue?vue&type=script&lang=js"
export * from "./CartCellChapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__